import { TLocation } from "ztypes/common";

export const AllLocation = [
  { name: "Việt Nam", id: TLocation.ALL },
  { name: "TP Hồ Chí Minh", id: TLocation.TP_HO_CHI_MINH },
  { name: "Hà Nội", id: TLocation.HA_NOI },
  { name: "Đà Nẵng", id: TLocation.DA_NANG },
  { name: "An Giang", id: TLocation.AN_GIANG },
  { name: "Bà Rịa Vũng Tàu", id: TLocation.BA_RIA_VUNG_TAU },
  { name: "Bình Dương", id: TLocation.BINH_DUONG },
  { name: "Bình Phước", id: TLocation.BINH_PHUOC },
  { name: "Bình Thuận", id: TLocation.BINH_THUAN },
  { name: "Bình Định", id: TLocation.BINH_DINH },
  { name: "Bạc Liêu", id: TLocation.BAC_LIEU },
  { name: "Bắc Giang", id: TLocation.BAC_GIANG },
  { name: "Bắc Kạn", id: TLocation.BAC_KAN },
  { name: "Bắc Ninh", id: TLocation.BAC_NINH },
  { name: "Bến Tre", id: TLocation.BEN_TRE },
  { name: "Cao Bằng", id: TLocation.CAO_BANG },
  { name: "Cà Mau", id: TLocation.CA_MAU },
  { name: "Cần Thơ", id: TLocation.CAN_THO },
  { name: "Đắk Lắk", id: TLocation.DAK_LAK },
  { name: "Đắk Nông", id: TLocation.DAK_NONG },
  { name: "Điện Biên", id: TLocation.DIEN_BIEN },
  { name: "Đồng Nai", id: TLocation.DONG_NAI },
  { name: "Đồng Tháp", id: TLocation.DONG_THAP },
  { name: "Gia Lai", id: TLocation.GIA_LAI },
  { name: "Hà Giang", id: TLocation.HA_GIANG },
  { name: "Hà Nam", id: TLocation.HA_NAM },
  { name: "Hà Tĩnh", id: TLocation.HA_TINH },
  { name: "Hải Dương", id: TLocation.HAI_DUONG },
  { name: "Hải Phòng", id: TLocation.HAI_PHONG },
  { name: "Hậu Giang", id: TLocation.HAU_GIANG },
  { name: "Hòa Bình", id: TLocation.HOA_BINH },
  { name: "Hưng Yên", id: TLocation.HUNG_YEN },
  { name: "Khánh Hòa", id: TLocation.KHANH_HOA },
  { name: "Kiên Giang", id: TLocation.KIEN_GIANG },
  { name: "Kon Tum", id: TLocation.KON_TUM },
  { name: "Lai Châu", id: TLocation.LAI_CHAU },
  { name: "Lạng Sơn", id: TLocation.LANG_SON },
  { name: "Lào Cai", id: TLocation.LAO_CAI },
  { name: "Lâm Đồng", id: TLocation.LAM_DONG },
  { name: "Long An", id: TLocation.LONG_AN },
  { name: "Nam Định", id: TLocation.NAM_DINH },
  { name: "Nghệ An", id: TLocation.NGHE_AN },
  { name: "Ninh Bình", id: TLocation.NINH_BINH },
  { name: "Ninh Thuận", id: TLocation.NINH_THUAN },
  { name: "Phú Thọ", id: TLocation.PHU_THO },
  { name: "Phú Yên", id: TLocation.PHU_YEN },
  { name: "Quảng Bình", id: TLocation.QUANG_BINH },
  { name: "Quảng Nam", id: TLocation.QUANG_NAM },
  { name: "Quảng Ngãi", id: TLocation.QUANG_NGAI },
  { name: "Quảng Ninh", id: TLocation.QUANG_NINH },
  { name: "Quảng Trị", id: TLocation.QUANG_TRI },
  { name: "Sóc Trăng", id: TLocation.SOC_TRANG },
  { name: "Sơn La", id: TLocation.SON_LA },
  { name: "Tây Ninh", id: TLocation.TAY_NINH },
  { name: "Thanh Hóa", id: TLocation.THANH_HOA },
  { name: "Thái Bình", id: TLocation.THAI_BINH },
  { name: "Thái Nguyên", id: TLocation.THAI_NGUYEN },
  { name: "Thừa Thiên Huế", id: TLocation.THUA_THIEN_HUE },
  { name: "Tiền Giang", id: TLocation.TIEN_GIANG },
  { name: "Trà Vinh", id: TLocation.TRA_VINH },
  { name: "Tuyên Quang", id: TLocation.TUYEN_QUANG },
  { name: "Vĩnh Long", id: TLocation.VINH_LONG },
  { name: "Vĩnh Phúc", id: TLocation.VINH_PHUC },
  { name: "Yên Bái", id: TLocation.YEN_BAI },
];

// export const AllLocation = [
//   { name: "Việt Nam", id: TLocation.ALL },
//   { name: "An Giang", id: TLocation.AN_GIANG },
//   { name: "Bến Tre", id: TLocation.BEN_TRE },
//   { name: "Cao Bằng", id: TLocation.CAO_BANG },
//   { name: "Đồng Tháp", id: TLocation.DONG_THAP },
//   { name: "Hải Phòng", id: TLocation.HAI_PHONG },
//   { name: "TP Hồ Chí Minh", id: TLocation.TP_HO_CHI_MINH },
//   { name: "Kiên Giang", id: TLocation.KIEN_GIANG },
//   { name: "Lâm Đồng", id: TLocation.LAM_DONG },
//   { name: "Long An", id: TLocation.LONG_AN },
//   { name: "Quảng Ninh", id: TLocation.QUANG_NINH },
//   { name: "Sơn La", id: TLocation.SON_LA },
//   { name: "Tây Ninh", id: TLocation.TAY_NINH },
//   { name: "Thanh Hóa", id: TLocation.THANH_HOA },
//   { name: "Thái Bình", id: TLocation.THAI_BINH },
//   { name: "Tiền Giang", id: TLocation.TIEN_GIANG },
//   { name: "Lạng Sơn", id: TLocation.LANG_SON },
//   { name: "Đồng Nai", id: TLocation.DONG_NAI },
//   { name: "Hà Nội", id: TLocation.HA_NOI },
//   { name: "Bà Rịa Vũng Tàu", id: TLocation.BA_RIA_VUNG_TAU },
//   { name: "Bình Định", id: TLocation.BINH_DINH },
//   { name: "Bình Thuận", id: TLocation.BINH_THUAN },
//   { name: "Gia Lai", id: TLocation.GIA_LAI },
//   { name: "Hà Giang", id: TLocation.HA_GIANG },
//   { name: "Hà Tĩnh", id: TLocation.HA_TINH },
//   { name: "Hòa Bình", id: TLocation.HOA_BINH },
//   { name: "Khánh Hòa", id: TLocation.KHANH_HOA },
//   { name: "Kon Tum", id: TLocation.KON_TUM },
//   { name: "Nghệ An", id: TLocation.NGHE_AN },
//   { name: "Ninh Bình", id: TLocation.NINH_BINH },
//   { name: "Ninh Thuận", id: TLocation.NINH_THUAN },
//   { name: "Phú Yên", id: TLocation.PHU_YEN },
//   { name: "Quảng Bình", id: TLocation.QUANG_BINH },
//   { name: "Quảng Ngãi", id: TLocation.QUANG_NGAI },
//   { name: "Quảng Trị", id: TLocation.QUANG_TRI },
//   { name: "Sóc Trăng", id: TLocation.SOC_TRANG },
//   { name: "Thừa Thiên Huế", id: TLocation.THUA_THIEN_HUE },
//   { name: "Trà Vinh", id: TLocation.TRA_VINH },
//   { name: "Tuyên Quang", id: TLocation.TUYEN_QUANG },
//   { name: "Vĩnh Long", id: TLocation.VINH_LONG },
//   { name: "Yên Bái", id: TLocation.YEN_BAI },
//   { name: "Bắc Giang", id: TLocation.BAC_GIANG },
//   { name: "Bắc Kạn", id: TLocation.BAC_KAN },
//   { name: "Bạc Liêu", id: TLocation.BAC_LIEU },
//   { name: "Bắc Ninh", id: TLocation.BAC_NINH },
//   { name: "Bình Dương", id: TLocation.BINH_DUONG },
//   { name: "Bình Phước", id: TLocation.BINH_PHUOC },
//   { name: "Cà Mau", id: TLocation.CA_MAU },
//   { name: "Đà Nẵng", id: TLocation.DA_NANG },
//   { name: "Hải Dương", id: TLocation.HAI_DUONG },
//   { name: "Hà Nam", id: TLocation.HA_NAM },
//   { name: "Hưng Yên", id: TLocation.HUNG_YEN },
//   { name: "Nam Định", id: TLocation.NAM_DINH },
//   { name: "Phú Thọ", id: TLocation.PHU_THO },
//   { name: "Quảng Nam", id: TLocation.QUANG_NAM },
//   { name: "Thái Nguyên", id: TLocation.THAI_NGUYEN },
//   { name: "Vĩnh Phúc", id: TLocation.VINH_PHUC },
//   { name: "Cần Thơ", id: TLocation.CAN_THO },
//   { name: "Đắk Lắk", id: TLocation.DAK_LAK },
//   { name: "Lai Châu", id: TLocation.LAI_CHAU },
//   { name: "Lào Cai", id: TLocation.LAO_CAI },
//   { name: "Đắk Nông", id: TLocation.DAK_NONG },
//   { name: "Điện Biên", id: TLocation.DIEN_BIEN },
//   { name: "Hậu Giang", id: TLocation.HAU_GIANG },
// ];
